import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class TorchAPIConfiguration {
  rootUrl = '';
  filesUrl = '';
}

/**
 * Parameters for `ApiModule.forRoot()`
 */
export interface TorchAPIConfigurationParams {
  rootUrl?: string;
  filesUrl?: string;
}
